const mutation = {
  initData(state) {
    state.isEmptyPaginate = false;
  },
  SET_PAYMENTS_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_PAYMENTS(state, data) {
    state.list = data;
  },

  SET_FILTER(state, data) {
    state.invoiceFilter = data;
  },

  SET_INVOICE_LOADING(state, status) {
    state.isInvoiceLoading = status;
  },

  SET_INVOICE(state, data) {
    state.invoicelist = data;
  },

  setComments(state, data) {
    state.comments = data;
  },
  commentLoading(state, status) {
    state.commentLoading = status;
  },
  setUploading(state, data) {
    state.isUploading = data;
  },
  setIndentFilter(state, data) {
    state.indentType = data;
  },
  setdeliveryType(state, data) {
    state.vehicleType = data;
  },
  setInvoiceFilter(state, data) {
    state.invoiceType = data;
  },

  SET_PAGINATED_DATA(state, data) {
    if (data.length > 0) {
      state.isEmptyPaginate = false;
      state.list = state.list.concat(data);
    } else {
      state.isEmptyPaginate = true;
    }
  },

  SET_PAGINATED_INVOICE_DATA(state, data) {
    if (data.length > 0) {
      state.isEmptyPaginate = false;
      state.invoicelist = state.invoicelist.concat(data);
    } else {
      state.isEmptyPaginate = true;
    }
  },

  SET_CLIENT(state, client) {
    state.client = client;
  },

  SET_ORDER_PROCESSING(state, status) {
    state.isOrderProcessing = status;
  },

  SET_ALL_ORDERS_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_ORDER(state, order) {
    state.order = order;
  },

  SET_ORDER_LOADING(state, status) {
    state.isOrderLoading = status;
  },

  SET_COUNT(state, count) {
    state.count = count;
  },

  SET_EMPTY_PAGINATE(state, status) {
    state.isEmptyPaginate = status;
  },

  SET_PAGINATION_STATUS(state, status) {
    state.isPaginating = status;
  },

  setPayment(state, data) {
    state.selected = data;
  },

  SET_ATTACHMENTS_IDS(state, data) {
    state.list.find(payment => payment.id === data.payment_id).consignees.find(consignee => consignee.id === data.consignee_id).lr_attachment_ids = data.lr_attachment_ids;
  },
};

export default mutation;
